import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Repairer,
  REPAIRER_TYPE,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}repairertype/repairers`;

export interface GetRepairersByTypeAndSellerIdRequestArgs {
  sellerId: string;
  repairerType: REPAIRER_TYPE;
}

export const getRepairersByTypeAndSellerIdRequest = ({
  sellerId,
  repairerType,
}: GetRepairersByTypeAndSellerIdRequestArgs): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT, { repairerType, sellerId }),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getRepairersByTypeAndSellerIdQuery = async (
  payload: GetRepairersByTypeAndSellerIdRequestArgs,
): Promise<BackResponse<Repairer[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Repairer[]>>(
      getRepairersByTypeAndSellerIdRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
